<template>

    <main-layout>

        <app-header icon="tools">
            {{ fibsdd.numero }}
        </app-header>

        <action-bar :back="{name:'liste-fibsdd'}">

        </action-bar>

        <div id="container-fi">

            <nav-fibsdd v-show="activeSection !== 'start'"
                        @changeSection="navigateTo">
            </nav-fibsdd>

            <section id="start" v-show="activeSection === 'start'">

                <small-recap :code="fibsdd.numero"
                             :ot="fibsdd.ordre_travail"
                             :detenteur="detenteur"
                             :installation="installation"
                             :gotFluide="isFluide"
                             :isFibsdd="isFibsdd">
                </small-recap>

                <voice-trigger-button v-if="showVoiceTrigger"
                                       :recording="voiceRecording"
                                       :loading="voiceLoading"
                                       @toggle="toggleVoiceRecording">
                </voice-trigger-button>

                <nature-choice :natures="fibsdd.natures"
                               @natureUpdated="updateNature"
                               @goToIntervention="navigateTo('intervention')"
                               :gotFluide="isFluide"
                               :isFibsdd="isFibsdd">
                </nature-choice>

            </section>

            <section id="intervention" v-show="activeSection === 'intervention'">

                <voice-trigger-button v-if="showVoiceTrigger"
                                       :recording="voiceRecording"
                                       :loading="voiceLoading"
                                       @toggle="toggleVoiceRecording">
                </voice-trigger-button>

                <controle-etanch :nofuite="fibsdd.ctrlEtanch.no_fuites" :open="activeSubsection" :detecteur="detecteur"
                                 @openCollapsible="openSubsection" @isValidChanged="updateValidCtrl"
                                 v-if="isFluide && (fibsdd.natures.controleNonPeriodique || fibsdd.natures.controlePeriodique)">
                </controle-etanch>

                <manip-fluide ref="manipFluide" :open="activeSubsection" :operations="fibsdd.operations" :idFi="fibsdd.id"
                              @newManip="updateManipFluide" @openCollapsible="openSubsection" v-if="isFluide">
                </manip-fluide>

                <infos :open="activeSubsection" :informations="fibsdd.informations" @infosChanged="updateInfos"
                       @openCollapsible="openSubsection">
                </infos>

                <gestion-pieces ref="gestionPieces" :open="activeSubsection" :pieces="fibsdd.pieces" @openCollapsible="openSubsection"
                                @infosChanged="updateInfos" @updatePieces="piecesChanged">

                </gestion-pieces>

                <a href="javascript: void 0" class="btn next" @click="navigateTo('finish')">
                    Finaliser
                    <i class="icon-go"></i>
                </a>

            </section>

            <section id="finish" v-show="activeSection === 'finish'">

                <div class="bandeau-end wrap">
                    Récapitulatif de l’intervention
                </div>

                <small-recap :code="fibsdd.numero"
                             :ot="fibsdd.ordre_travail"
                             :detenteur="detenteur"
                             :installation="installation"
                             :gotFluide="isFluide"
                             :isFibsdd="isFibsdd">
                </small-recap>

                <recap :fibsdd="fibsdd" :fuites="this.fuites"></recap>

                <client-infos :infosDet="fibsdd.infosDet" @infosDetUpdated="updateInfosDet"></client-infos>

                <a class="btn btn-full main-action cloturer"
                   id="main-action"
                   style="margin: 20px 5px;"
                   :class="classClotureWithSignature"
                   @click.prevent="triggerSignature">

                    <i class="icon-checktodo"></i>
                    <strong>Signer et Clôturer </strong> l'intervention

                </a>

                <a class="btn btn-green main-action cloturer"
                   id="clotureWithoutSignature"
                   style="margin: 20px 5px;"
                   :class="classClotureWithoutSignature"
                   @click.prevent="triggerBypassSignature"
                >
                    <i class="icon-error"></i>
                    <strong>Clôturer détenteur absent</strong> l'intervention
                </a>





                <signature-modal
                        v-show="showModal"
                        :signature="fibsdd.infosDet.signature_signataire64"
                        :clearOnClose="true"
                        @signatureUpdated="updateSignature"
                        @close="showModal = false">
                </signature-modal>

            </section>



        </div>

        <voice-intervention-modal
                v-if="showVoiceModal"
                :transcript="voiceData.transcript"
                :fields="voiceData.fields"
                :current="voiceCurrentValues"
                :bottle-match="voiceBottleMatch"
                :loading="voiceLoading"
                @confirm="applyVoiceProposals"
                @reanalyze="reanalyzeVoiceTranscript"
                @close="showVoiceModal = false">
        </voice-intervention-modal>

    </main-layout>

</template>

<script>

    // SPECIFIC
    import NavFibsdd from './subcomponents/Nav.vue'
    import SmallRecap from './subcomponents/SmallRecap.vue'
    import NatureChoice from './subcomponents/Nature.vue'
    import ControleEtanch from './subcomponents/ControlEtanch.vue'
    import ManipFluide from './subcomponents/ManipFluide.vue'
    import Infos from './subcomponents/Infos.vue'
    import Recap from './subcomponents/Recap.vue'
    import ClientInfos from './subcomponents/ClientInfos.vue'
    import GestionPieces from './subcomponents/GestionPieces.vue'
    import SignatureModal from '../../common/SignatureModal.vue'
    import VoiceInterventionModal from './subcomponents/VoiceInterventionModal.vue'
    import VoiceTriggerButton from './subcomponents/VoiceTriggerButton.vue'

    // OBJETS JS
    import Fibsdd from '../../../js/models/Fibsdd'
    import User from '../../../js/models/User'
    import Detenteur from '../../../js/models/Detenteur'
    import Outil from '../../../js/models/Outil'
    import Installation from '../../../js/models/Installation'
    import OperationBouteille from '../../../js/models/OperationBouteille'
    import Bouteille from '../../../js/models/Bouteille'
    import Fuite from '../../../js/models/Fuite'
    import Piece from '../../../js/models/Piece'
    import Offline from '../../../js/models/Offline'
    import localforage from 'localforage'

    export default {

        data() {
            return {

                fibsdd: {

                    id: null,
                    ordre_travail: null,
                    numero: null,
                    detenteur: null,
                    installation: null,
                    fluide_init: null,
                    charge_init: null,

                    natures: {
                        assemblage: false,
                        miseEnService: false,
                        modification: false,
                        maintenance: false,
                        controlePeriodique: false,
                        controleNonPeriodique: false,
                        demantelement: false,
                        retrofit: false,
                        newFluide: null,
                        autres: null,
                        observations: null
                    },

                    ctrlEtanch: {
                        fuites: [],
                        no_fuites: false
                    },

                    operations: [],

                    informations: {
                        temps_deplacement: null,
                        temps_intervention: null,
                        pieces: null,
                        observations: null,
                        photo: null,
                        techs: null,
                        namesTechniciens: null,
                        finish: null,
                        garantie: null,
                        fromDevis: null,
                        needDevis: null,
                        preventif: null,
                        correctif: null,
                        travauxEffectues: null
                    },

                    pieces: [],

                    photos: [],

                    infosDet: {
                        nom_signataire: null,
                        qualite_signataire: null,
                        signature_signataire64: null
                    },

                    sendMail: null,
                    cloture: null,
                    callback: null

                },

                installation: {},
                detenteur: {},
                fuites: [],
                detecteur: {},
                technicien: {},

                interventionIsValid: null,
                infosDetIsValid: true,

                activeSection: 'start',
                activeSubsection: null,

                showModal: false,
                closing: false,

                isFluide: null,
                isFibsdd: null,

                navigatorOnline: navigator.onLine,
                showVoiceModal: false,
                voiceRecording: false,
                voiceLoading: false,
                voiceMediaRecorder: null,
                voiceRecordingTimeout: null,
                voiceChunks: [],
                voiceData: {transcript: '', fields: {}},
                voiceBottleMatch: null

            }
        },

        computed: {

            showVoiceTrigger() {
                return this.navigatorOnline && this.$user && this.$user.id === 2600 && this.activeSection !== 'finish'
            },

            voiceCurrentValues() {
                return {
                    heure_arrivee: this.fibsdd.informations.heure_arrivee,
                    heure_depart: this.fibsdd.informations.heure_depart,
                    controle_periodique: this.fibsdd.natures.controlePeriodique,
                    controle_non_periodique: this.fibsdd.natures.controleNonPeriodique,
                    kilometrage: this.fibsdd.informations.kilometrage,
                    travaux_effectues: this.fibsdd.informations.travauxEffectues,
                    observations: this.fibsdd.informations.observations,

                    intervention_contractuelle: this.fibsdd.natures.contractuel,
                    description_demande: this.fibsdd.natures.description,
                    assemblage: this.fibsdd.natures.assemblage,
                    mise_en_service: this.fibsdd.natures.miseEnService,
                    modification: this.fibsdd.natures.modification,
                    maintenance: this.fibsdd.natures.maintenance,
                    demantelement: this.fibsdd.natures.demantelement,
                    autre_nature: this.fibsdd.natures.autres,
                    observations_nature: this.fibsdd.natures.observations,

                    temps_deplacement: this.fibsdd.informations.temps_deplacement,
                    temps_intervention: this.fibsdd.informations.temps_intervention,
                    nombre_techniciens: this.fibsdd.informations.techs,
                    noms_techniciens: this.fibsdd.informations.namesTechniciens,
                    preventif: this.fibsdd.informations.preventif,
                    correctif: this.fibsdd.informations.correctif,
                    selon_devis: this.fibsdd.informations.fromDevis,
                    garantie: this.fibsdd.informations.garantie,
                    travaux_termines: this.fibsdd.informations.finish,
                    devis_a_realiser: this.fibsdd.informations.needDevis
                }
            },

            clotureLocked() {
                return this.closing || this.fibsdd.cloture === true
            },

            classClotureWithSignature() {
                if (this.clotureLocked) {
                    return 'disabled'
                } else if ((this.fibsdd.natures.controlePeriodique === false && this.fibsdd.natures.controleNonPeriodique === false) && this.infosDetIsValid === true) {
                    return ''
                } else if (this.interventionIsValid === true && this.infosDetIsValid === true) {
                    return ''
                } else if (!this.installation.fluide && this.infosDetIsValid === true) {
                    return ''
                } else {
                    return 'disabled'
                }
            },

            classClotureWithoutSignature() {
                if (this.clotureLocked) {
                    return 'disabled'
                } else if (!this.fibsdd.infosDet.nom_signataire && !this.fibsdd.infosDet.fonction_signataire) {
                    return ''
                } else {
                    return 'disabled'
                }
            }

        },

        methods: {

            // NAVIGATION ACTIONS
            piecesChanged(pieces) {
                let piecesToSave = [];
                for (let p of pieces) {
                    piecesToSave.push(p)
                }

                let fi = new Fibsdd;
                this.fibsdd.pieces = piecesToSave;
                let idFi = this.$route.params.id;

                fi.updateFibsdd(idFi, this.fibsdd, () => {

                })
            },

            // Contrôle d'étanchéité sur une installation avec fluide : un détecteur
            // de fuites manuel valide est obligatoire (même règle que l'API).
            detecteurManquant() {
                return _.isEmpty(this.detecteur)
                    && !!this.installation.fluide
                    && (this.fibsdd.natures.controlePeriodique === true || this.fibsdd.natures.controleNonPeriodique === true);
            },

            navigateTo(section) {

                if (section === 'intervention') {

                    if (this.detecteurManquant()) {
                        swal('Détecteur de fuites requis', "Vous devez ajouter et activer un détecteur de fuites manuel valide pour pouvoir faire un contrôle d'étanchéité.", 'warning');
                    } else {
                        document.getElementById('goto-intervention').classList.remove('actif');
                        document.getElementById('goto-finish').classList.remove('actif');
                        this.activeSection = section
                    }

                } else if (section === 'finish') {

                    // MD-780 : sans ce contrôle, on pouvait clôturer un contrôle
                    // d'étanchéité sans détecteur depuis l'onglet « Fin » ; le
                    // serveur le refuse et la fiche restait bloquée en synchro.
                    if (this.detecteurManquant()) {
                        swal('Détecteur de fuites requis', "Vous devez ajouter et activer un détecteur de fuites manuel valide pour pouvoir faire un contrôle d'étanchéité.", 'warning');
                        return;
                    }

                    this.fetchFuites();
                    if (this.interventionIsValid ||
                        (this.fibsdd.natures.controlePeriodique === false && this.fibsdd.natures.controleNonPeriodique === false) ||
                        ! this.installation.fluide
                    ) {

                        document.getElementById('goto-intervention').classList.add('actif');
                        this.activeSection = section;

                        if (this.infosDetIsValid) {
                            document.getElementById('goto-finish').classList.add('actif')
                        }

                    } else {
                        swal('Fiche incomplète', "Veuillez compléter le contrôle d'étanchéité", 'warning')
                    }

                } else {

                    document.getElementById('goto-intervention').classList.remove('actif');
                    document.getElementById('goto-finish').classList.remove('actif');
                    this.activeSection = section

                }

            },

            openSubsection(type) {
                if (this.activeSubsection === type) {
                    this.activeSubsection = null
                } else {
                    this.activeSubsection = type
                }
            },

            updateValidCtrl(status) {
                this.fibsdd.ctrlEtanch.no_fuites = status.no_fuites;
                this.interventionIsValid = status.isValid
            },

            // FETCHING DATA
            // todo : clean ça !!
            fetchFibsddData() {

                return new Promise((resolve) => {

                    let fi = new Fibsdd;
                    let idFiche = this.$route.params.id;

                    fi.getFibsdd(idFiche).then(dataFi => {

                        this.fibsdd.id = dataFi.id;
                        this.fibsdd.numero = dataFi.numero;
                        this.fibsdd.ordre_travail = dataFi.ordre_travail;
                        this.fibsdd.detenteur = dataFi.detenteur;
                        this.fibsdd.installation = dataFi.installation;
                        this.fibsdd.charge_init = dataFi.charge_init;
                        this.fibsdd.fluide_init = dataFi.fluide_init;
                        this.fibsdd.cloture = dataFi.cloture === true;
                        this.fibsdd.cloturedAt = dataFi.cloturedAt;
                        this.fibsdd.photos = dataFi.photos;
                        this.fibsdd.natures = dataFi.natures;
                        this.fibsdd.ctrlEtanch.no_fuites = dataFi.ctrlEtanch.no_fuites;
                        this.fibsdd.informations = dataFi.informations;
                        this.fibsdd.infosDet = dataFi.infosDet;
                        // Conserver le callback s'il est présent
                        if (dataFi.hasOwnProperty('callback') && dataFi.callback !== null) {
                            this.fibsdd.callback = dataFi.callback;
                        }

                        // VALID STATUS
                        if (this.fibsdd.ctrlEtanch.no_fuites === true) {
                            this.interventionIsValid = true
                        }

                        if (!this.fibsdd.infosDet.nom_signataire) {
                            this.infosDetIsValid = false
                        }
                        if (!this.fibsdd.infosDet.fonction_signataire) {
                            this.infosDetIsValid = false
                        }

                        resolve(true)

                    })

                })

            },

            fetchTechnicienData() {

                Outil
                    .getDetecteurActif()
                    .then(data => {
                        this.fibsdd.detecteur = data.id;
                        this.detecteur = data
                    })
                    .catch(() => {});

                User
                    .getUserData(data => {
                        this.technicien = data
                    })

            },

            fetchOperations() {

                let ops = new OperationBouteille;
                let idFiche = this.$route.params.id;

                ops
                    .getOpsForFibsdd(idFiche)
                    .then(data => {
                        this.fibsdd.operations = data
                    })
                    .catch()

            },

            fetchPieces() {

                let idFiche = this.$route.params.id;

                Piece
                    .getListForFiche(idFiche)
                    .then(res => this.fibsdd.pieces = res)
                    .catch()

            },

            async fetchDetAndInstall() {

                this.detenteur = await Detenteur.getDetenteur(this.fibsdd.detenteur);
                this.installation = await Installation.getInstallation(this.fibsdd.installation);


                if (_.isEmpty(this.installation.fluide)) {

                    this.isFluide = false;
                    this.isFibsdd = false

                } else if(this.installation.fluide.id === 44) {
                  //Si R999, popup changement de fluide !!!
                    swal('Fluide non autorisé', "Veuillez remplacer le fluide R-999 de l'installation par un fluide existant.", 'error');

                    swal({
                        title: 'Fluide non autorisé',
                        text: 'Veuillez remplacer le fluide R-999 de l\'installation par un fluide existant.',
                        type: 'error',
                        showCancelButton: false,
                        confirmButtonText: 'Ok',
                    }).then(
                        () => this.$router.push({name: "installation", params: {idInst: this.installation.id, id: this.detenteur.id}})
                    )
                } else {

                    this.fibsdd.charge_init = this.installation.charge;
                    this.fibsdd.fluide_init = this.installation.fluide.id;

                    this.isFluide = true;
                    let typeFluide = this.installation.fluide.type;

                    if (typeFluide === 'HFC' || typeFluide === 'HCFC' || typeFluide === 'CFC' || typeFluide === 'Mélange HFO/HFC') {
                        this.isFibsdd = true
                    } else {
                        this.isFibsdd = false
                    }


                }

            },

            fetchFuites() {
                return new Promise((resolve, reject) => {
                    Fuite
                        .getListForFibsdd(this.$route.params.id)
                        .then(res => {
                            this.fuites = res;
                            resolve(res)
                        })
                        .catch(err => reject(err))
                })
            },

            // UPDATE DATA

            updateInfosDet(status) {
                this.infosDetIsValid = status;

                this.updateFi()

            },

            updateFi() {
                let fi = new Fibsdd;
                let idFi = this.$route.params.id;

                fi.updateFibsdd(idFi, this.fibsdd, () => {

                })

            },

            updateNature(natures) {

                let fi = new Fibsdd;
                this.fibsdd.natures = natures;
                let idFi = this.$route.params.id;

                fi.updateFibsdd(idFi, this.fibsdd, () => {

                })

            },

            updateManipFluide(operations) {
                this.fibsdd.operations = operations[0]
            },

            // EXTRACTION VOCALE (PILOTE)

            toggleVoiceRecording() {
                if (this.voiceRecording) {
                    this.stopVoiceRecording();
                } else {
                    this.startVoiceRecording();
                }
            },

            startVoiceRecording() {
                navigator.mediaDevices.getUserMedia({audio: true})
                    .then(stream => {

                        const mimeType = MediaRecorder.isTypeSupported('audio/webm;codecs=opus')
                            ? 'audio/webm;codecs=opus'
                            : (MediaRecorder.isTypeSupported('audio/mp4') ? 'audio/mp4' : '');

                        this.voiceMediaRecorder = mimeType ? new MediaRecorder(stream, {mimeType}) : new MediaRecorder(stream);
                        this.voiceChunks = [];

                        this.voiceMediaRecorder.ondataavailable = e => {
                            if (e.data.size > 0) {
                                this.voiceChunks.push(e.data);
                            }
                        };

                        this.voiceMediaRecorder.onstop = () => {
                            stream.getTracks().forEach(track => track.stop());
                            const blob = new Blob(this.voiceChunks, {type: this.voiceMediaRecorder.mimeType});
                            this.processVoiceRecording(blob);
                        };

                        this.voiceMediaRecorder.start();
                        this.voiceRecording = true;

                        // Limite de sécurité pour éviter un enregistrement trop long / trop lourd
                        this.voiceRecordingTimeout = setTimeout(() => {
                            if (this.voiceRecording) {
                                this.stopVoiceRecording();
                            }
                        }, 90000);

                    })
                    .catch(() => {
                        swal('Erreur', "Impossible d'accéder au microphone.", 'error');
                    })
            },

            stopVoiceRecording() {
                if (this.voiceMediaRecorder && this.voiceRecording) {
                    clearTimeout(this.voiceRecordingTimeout);
                    this.voiceMediaRecorder.stop();
                    this.voiceRecording = false;
                }
            },

            processVoiceRecording(blob) {
                const reader = new FileReader();

                reader.onloadend = () => {
                    this.runVoiceExtraction({audio64: reader.result}, "L'analyse de l'enregistrement a échoué")
                        .then(success => {
                            if (success) {
                                this.showVoiceModal = true;
                            }
                        })
                };

                reader.readAsDataURL(blob);
            },

            // Ré-analyse un transcript corrigé manuellement par le technicien (sans repasser par l'audio)
            reanalyzeVoiceTranscript(transcript) {
                this.runVoiceExtraction({transcript}, 'La ré-analyse a échoué')
            },

            // payload : { audio64 } ou { transcript }. Résout à true/false selon le succès (ne rejette jamais).
            runVoiceExtraction(payload, errorTitle) {
                this.voiceLoading = true;

                return Fibsdd
                    .voiceExtract(payload)
                    .then(async data => {

                        this.voiceLoading = false;
                        this.voiceData = data;

                        if (data.fields.operation_bouteille) {
                            const op = new OperationBouteille;
                            this.voiceBottleMatch = await op.matchBouteilleFromVoice(
                                data.fields.operation_bouteille.code_bouteille,
                                data.fields.operation_bouteille.type_operation,
                                this.fibsdd,
                                this.installation
                            );
                            this.voiceBottleMatch.quantiteProposee = data.fields.operation_bouteille.quantite_kg;
                        } else {
                            this.voiceBottleMatch = null;
                        }

                        return true;

                    })
                    .catch(err => {
                        this.voiceLoading = false;
                        const detail = typeof err === 'string' ? err : (err && err.message) || '';
                        swal('Erreur', errorTitle + (detail ? ' : ' + detail : '') + ', veuillez réessayer.', 'error');
                        return false;
                    })
            },

            applyVoiceProposals(selection) {
                const champs = selection.champs;

                const infosFields = [
                    'heure_arrivee', 'heure_depart', 'kilometrage', 'travaux_effectues', 'observations',
                    'temps_deplacement', 'temps_intervention', 'nombre_techniciens', 'noms_techniciens',
                    'preventif', 'correctif', 'selon_devis', 'garantie', 'travaux_termines', 'devis_a_realiser',
                ];
                const infosMap = {
                    travaux_effectues: 'travauxEffectues',
                    nombre_techniciens: 'techs',
                    noms_techniciens: 'namesTechniciens',
                    selon_devis: 'fromDevis',
                    travaux_termines: 'finish',
                    devis_a_realiser: 'needDevis',
                };
                let infosChanged = false;

                // Préventif / correctif sont mutuellement exclusifs (comme dans Infos.vue::typeUniqueCheck)
                if (champs.preventif === true && champs.correctif === true) {
                    champs.correctif = false;
                }

                infosFields.forEach(key => {
                    if (champs.hasOwnProperty(key)) {
                        this.$set(this.fibsdd.informations, infosMap[key] || key, champs[key]);
                        infosChanged = true;
                    }
                });

                if (infosChanged) {
                    this.updateInfos(this.fibsdd.informations);
                }

                const natureFields = ['assemblage', 'demantelement'];
                const natureMap = {
                    intervention_contractuelle: 'contractuel',
                    description_demande: 'description',
                    mise_en_service: 'miseEnService',
                    autre_nature: 'autres',
                    observations_nature: 'observations',
                };
                let natureChanged = false;
                let cascadeCtrlNonPeriodique = false;

                ['intervention_contractuelle', 'description_demande', ...natureFields, 'mise_en_service', 'autre_nature', 'observations_nature'].forEach(key => {
                    if (champs.hasOwnProperty(key)) {
                        let value = champs[key];
                        if (key === 'autre_nature' && typeof value === 'string') {
                            value = value.slice(0, 50);
                        }
                        this.fibsdd.natures[natureMap[key] || key] = value;
                        natureChanged = true;
                    }
                });

                ['modification', 'maintenance'].forEach(key => {
                    if (champs.hasOwnProperty(key)) {
                        this.fibsdd.natures[key] = champs[key];
                        natureChanged = true;
                        if (champs[key] === true && this.isFluide) {
                            cascadeCtrlNonPeriodique = true;
                        }
                    }
                });

                if (champs.hasOwnProperty('controle_periodique') && this.canApplyControleEtanch(champs.controle_periodique)) {
                    this.fibsdd.natures.controlePeriodique = champs.controle_periodique;
                    natureChanged = true;
                }

                const wantsControleNonPeriodique = champs.hasOwnProperty('controle_non_periodique')
                    ? champs.controle_non_periodique
                    : (cascadeCtrlNonPeriodique ? true : null);

                if (wantsControleNonPeriodique !== null && this.canApplyControleEtanch(wantsControleNonPeriodique)) {
                    this.fibsdd.natures.controleNonPeriodique = wantsControleNonPeriodique;
                    natureChanged = true;
                }

                if (natureChanged) {
                    this.updateNature(this.fibsdd.natures);
                }

                if (selection.bouteille) {
                    this.applyVoiceBottleOperation(selection.bouteille);
                }

                if (selection.fourniture) {
                    this.applyVoiceFourniture(selection.fourniture);
                }

                this.showVoiceModal = false;
            },

            // Rejoue le garde-fou détecteur normalement appliqué dans navigateTo('intervention'),
            // qui ne serait pas rejoué si on est déjà sur cette section.
            canApplyControleEtanch(willBeActive) {
                if (willBeActive !== true) {
                    return true;
                }

                if (_.isEmpty(this.detecteur) && this.installation.fluide) {
                    swal('Détecteur de fuites requis', "Vous devez ajouter et activer un détecteur de fuites manuel valide pour pouvoir faire un contrôle d'étanchéité. Ce champ dicté n'a pas été appliqué.", 'warning');
                    return false;
                }

                return true;
            },

            applyVoiceBottleOperation(bouteilleSelection) {
                let opObj = new OperationBouteille;

                localforage.getItem('profil').then(res => {
                    const profil = JSON.parse(res);
                    const op = opObj.buildOperation(this.fibsdd.id, bouteilleSelection.bouteilleId, bouteilleSelection.typeOp, bouteilleSelection.quantite, profil);

                    opObj.addOfflineOperation(op).then(() => {
                        Bouteille.applyOperation(op).then(() => {
                            this.$refs.manipFluide.addValidatedOperation(op);
                        })
                    })
                })
            },

            applyVoiceFourniture(fournitureSelection) {
                const piece = {
                    id: 'P-' + +new Date(),
                    fiche: this.$route.params.id,
                    designation: fournitureSelection.designation,
                    etat: fournitureSelection.etat,
                    qte: fournitureSelection.quantite,
                    prix: fournitureSelection.prix_unitaire
                };

                this.$refs.gestionPieces.addValidatedPiece(piece);
            },

            updateInfos(infos) {

                let fi = new Fibsdd;
                this.fibsdd.informations = infos;
                // Pas $route : au flush de beforeDestroy d'Infos, la route pointe déjà ailleurs (MD-929).
                let idFi = this.fibsdd.id != null ? String(this.fibsdd.id) : this.$route.params.id;

                fi.updateFibsdd(idFi, this.fibsdd, () => {

                })
            },

            triggerSignature() {
                if (this.clotureLocked) {
                    return
                }
                if (this.classClotureWithSignature === 'disabled') {
                    swal('Fiche incomplète', 'Veuillez renseigner le nom et la fonction du signataire avant de clôturer la fiche.', 'warning')
                } else {
                    this.showModal = true
                }
            },

            triggerBypassSignature() {
                if (this.clotureLocked) {
                    return
                }
                if (this.classClotureWithoutSignature === 'disabled') {
                    swal('Info', 'Si vous souhaitez cloturer cette fiche sans signature, laisser les champs "Nom détenteur" et "Fonction" vides', 'warning')
                }else{
                    swal({
                        title: 'Clôturer sans signature ?',
                        text: "La fiche sera clôturée sans signature du détenteur. Cette action est définitive.",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Clôturer',
                        cancelButtonText: 'Annuler',
                    }).then(() => {
                        this.closeFibsdd()
                    }, () => {})
                }
            },

            async closeFibsdd() {
                if (this.clotureLocked) {
                    return
                }
                if (this.detecteurManquant()) {
                    swal('Détecteur de fuites requis', "Vous devez ajouter et activer un détecteur de fuites manuel valide pour pouvoir faire un contrôle d'étanchéité.", 'warning');
                    return;
                }
                this.closing = true;

                let fi = new Fibsdd;
                let idFi = this.$route.params.id;

                try {
                    // RETROFIT
                    if (this.fibsdd.natures.retrofit === true) {
                        await Installation.applyRetrofit(this.fibsdd.installation, this.fibsdd.id, this.fibsdd.natures.newFluide)
                    }

                    // DEMANTELEMENT
                    if (this.fibsdd.natures.demantelement === true) {
                        await Installation.applyDemantelement(this.fibsdd.installation)
                    }
                } catch (e) {
                    this.closing = false;
                    swal('Erreur', "La fiche n'a pas pu être clôturée, veuillez réessayer.", 'error');
                    return
                }

                this.fibsdd.cloture = true;
                this.fibsdd.cloturedAt = moment().format('YYYY-MM-DD HH:mm:ss');

                this.fibsdd.multiCtrl = false;

                let next = function (vue) {
                    const goNext = () => {
                        if(navigator.onLine) {
                            swal({
                                title: 'Synchronisation',
                                text: "Vous êtes connecté à internet.\nVoulez-vous synchroniser maintenant ?",
                                type: 'question',
                                showCancelButton: true,
                                confirmButtonText: 'Oui',
                                cancelButtonText: 'Non',
                                allowOutsideClick: false,
                            }).then(
                                () => {
                                    vue.$router.push({name: 'synchro'})
                                },
                                () => {
                                    vue.$router.push({name: 'home'})
                                }
                            );
                        } else {
                            vue.$router.push({name: 'home'})
                        }
                    };
                    swal('Fiche clôturée', "La fiche d'intervention a bien été générée", 'success').then(goNext, goNext)
                };

                if (this.detenteur.email !== null && this.detenteur.email !== '' && this.detenteur.email !== undefined) {

                    swal({
                        title: 'Envoi du rapport',
                        text: "Voulez vous envoyer la fiche d'intervention au détenteur ?",
                        type: 'question',
                        confirmButtonText: 'Oui',
                        showCancelButton: true,
                        cancelButtonText: 'Non',
                        allowOutsideClick: false
                    }).then(
                        () => {
                            this.fibsdd.sendMail = true;

                            Offline.saveAction({
                                action: 'add',
                                type: 'clotureFibsdd',
                                sendMail: true,
                                detenteur: this.fibsdd.detenteur,
                                idFi: this.fibsdd.id
                            });

                            fi.updateFibsdd(idFi, this.fibsdd, () => {
                                next(this)
                            })

                        },
                        () => {
                            this.fibsdd.sendMail = false;

                            Offline.saveAction({
                                action: 'add',
                                type: 'clotureFibsdd',
                                sendMail: false,
                                detenteur: this.fibsdd.detenteur,
                                idFi: this.fibsdd.id
                            });

                            fi.updateFibsdd(idFi, this.fibsdd, () => {
                                next(this)
                            })
                        }
                    )

                } else {

                    this.fibsdd.sendMail = false;

                    Offline.saveAction({
                        action: 'add',
                        type: 'clotureFibsdd',
                        sendMail: false,
                        detenteur: this.fibsdd.detenteur,
                        idFi: this.fibsdd.id
                    });

                    fi.updateFibsdd(idFi, this.fibsdd, () => {
                        next(this)
                    })
                }
            },

            updateSignature(data) {

                this.fibsdd.infosDet.signature_signataire64 = data;

                this.closeFibsdd()

            }
        },

        mounted() {


            this
                .fetchFibsddData()
                .then(() => {
                    if (this.fibsdd.cloture === true) {
                        const leave = () => this.$router.replace({name: 'liste-fibsdd'});
                        swal('Fiche déjà clôturée', "Cette fiche d'intervention est clôturée et ne peut plus être modifiée.", 'info').then(leave, leave);
                        return
                    }
                    this.fetchTechnicienData();
                    this.fetchOperations();
                    this.fetchDetAndInstall();
                    this.fetchPieces()
                })


        },

        components: {
            SmallRecap,
            NatureChoice,
            ControleEtanch,
            ManipFluide,
            Infos,
            NavFibsdd,
            Recap,
            ClientInfos,
            GestionPieces,
            SignatureModal,
            VoiceInterventionModal,
            VoiceTriggerButton
        }

    }

</script>

<style>

    form.textarea {
        min-block-size: 75px;
        resize: none;
    }

    #container-fi section h2 {
        color: #333333;
        font-family: "Open Sans";
        font-size: 1.5rem;
        font-weight: 700;
        text-transform: uppercase;
        margin-bottom: 20px;
    }

    a.btn.next {
        margin-bottom: 20px;
        width: 200px;
        margin: auto;
        text-align: center;
        padding-left: 35px;
        font-size: 1.5rem;
        font-weight: 400;
        color: #fbfafa;
        background-color: #5698d2;
        margin-bottom: 20px;
    }

    .collapsible {
        margin-bottom: 5px;
    }

    .collapsible.open .collapsible-head {
        background-color: #393c51;
        color: white;
    }

    .collapsible.open .collapsible-head i {
        -webkit-transform: translateY(-50%) rotate(-90deg);
        transform: translateY(-50%) rotate(-90deg);
        color: white;
    }

    .collapsible.open .collapsible-body {
        display: block;
        padding-top: 15px;
    }

    .collapsible .collapsible-head {
        position: relative;
        display: flex;
        align-items: center;
        min-height: 50px;
        width: 100%;
        background-color: #ccc;
        color: #333;
        font-size: 1.4rem;
        font-weight: 700;
        text-transform: uppercase;
        padding-right: 40px;
        line-height: normal;
        transition: all 250ms ease;
    }

    .collapsible .collapsible-head i {
        position: absolute;
        right: 10px;
        top: 50%;
        -webkit-transform: translateY(-50%) rotate(90deg);
        transform: translateY(-50%) rotate(90deg);
        font-size: 2.2rem;
        transition: all 250ms ease;
    }

    .collapsible .collapsible-body {
        display: none;
    }

    #finish .bandeau-end {
        display: flex;
        align-items: center;
        min-height: 50px;
        background-color: #393c51;
        color: #fbfafa;
        font-size: 1.4rem;
        font-weight: 700;
        text-transform: uppercase;
        line-height: normal;
    }

    #intervention a.btn.next {
        background-color: #5698d2;
        color: white;
        width: 200px;
        padding-left: 20px;
        margin: auto;
        margin-top: 15px;
        margin-bottom: 20px;
        font-size: 1.28rem;
    }

    pre {
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
    }

    .end-intervention {
        margin-bottom: 25px;
    }

    #main-action {
        flex-grow: 1;

    }

    .btn-green {
        background-color: #85bc23;
        color: white;
    }

    .btn-green i {
        right: 5px;
        top: 50%;
        margin-top: -17px;
        font-size: 3rem;
    }

</style>



// WEBPACK FOOTER //
// Fibsdd.vue?0878137c